import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { RiparianRequestsComponent } from './components/riparian-requests/riparian-requests.component';
import { HomeParkingRequestsComponent } from './components/home-parking-requests/home-parking-requests.component';
import { AuthGuard } from './guards/auth.guard';
import { UsersComponent } from './components/users/users.component';
import { ParkingRequestDetailsComponent } from './components/parking-request-details/parking-request-details.component';
import { UserDetailsComponent } from './components/user-details/user-details.component';
import { ParkingAgentsComponent } from './components/parking-agents/parking-agents.component';
import { TicketsComponent } from './components/tickets/tickets.component';
import { SubscriptionsComponent } from './components/subscriptions/subscriptions.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/',
    pathMatch: 'full',
  },
  {
    path: '',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'riparian-requests',
        component: RiparianRequestsComponent,
        pathMatch: 'full',
      },
      {
        path: 'home-parking-requests',
        component: HomeParkingRequestsComponent,
        pathMatch: 'full',
      },
      {
        path: 'parking-request-details/:requestId',
        component: ParkingRequestDetailsComponent,
        pathMatch: 'full',
      },
      {
        path: 'parking-agents',
        component: ParkingAgentsComponent,
        pathMatch: 'full',
      },
      {
        path: 'users',
        component: UsersComponent,
        pathMatch: 'full',
      },
      {
        path: 'user-details/:userId',
        component: UserDetailsComponent,
        pathMatch: 'full',
      },
      {
        path: 'tickets',
        component: TicketsComponent,
        pathMatch: 'full',
      },
      {
        path: 'subscriptions',
        component: SubscriptionsComponent,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'Admin-Parking-Oradea - Login ' },
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
